import classNames from 'classnames';
import React from 'react';

import { FilterOptionViewModel } from '../FilterOptionViewModel.csharp';

interface CategoriesTreeCategoryProps {
    category: FilterOptionViewModel;
    categoryKey: string;
    onChangeOption: (filterKey: string, subfilterKey: string | null, optionKey: string, isSelected: boolean, isSubfilter?: boolean) => void;
}

export const CategoriesTreeCategory = ({ category, onChangeOption, categoryKey }: CategoriesTreeCategoryProps) => {
    return (
        <ul className="CategoriesTree__Category">
            {category.children.map((children) =>
                children.count > 0 ? (
                    <li
                        key={children.key}
                        className={classNames('CategoriesTree__Subcategory', children.isSelected && 'CategoriesTree__Subcategory--Active')}
                        onClick={() => onChangeOption(categoryKey, category.key, children.key, true, true)}
                    >
                        {children.value} ({children.count})
                    </li>
                ) : null
            )}
        </ul>
    );
};
